function openDropdown() {
	$(document).on("click", ".dropdownTrigger", function() {
		var dropdownContent = $(this).siblings(".dropdownContent");
		var dropdown = $(this, dropdownContent);

		if (!dropdownContent.hasClass("is-open")) {
			$(this).addClass("open");
			setTimeout(fun, 1);
			function fun() {
				dropdownContent.addClass("is-open");
			}
			dropdownContent.addClass("transitioning");
		} else {
			$(this).removeClass("open");
			dropdownContent.removeClass("is-open");
		}
	});

	dropdownContent.on("transitionend", function(e) {
		if (!$(this).hasClass("is-open")) {
			$(this).removeClass("transitioning");
		}
	});
}

function dropdownClickContentClose(e) {
	if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
		$(".dropdownContent").removeClass("is-open");
		$(".dropdownTrigger").removeClass("open");
		e.stopPropagation();
	}
}